export default __webpack_public_path__ + "static/media/feather_close.ac1829b1.svg";